import React from 'react';
import styles from './AccordionSummaryWrapper.module.scss';

export function AccordionSummaryWrapper({ children }) {
  return <div className={styles.wrapper}>{children}</div>;
}
